import { createContext, useContext } from 'react';
import type { MessageKey } from './messages';

export type Lang = 'en' | 'th';

export const LANGS: { value: Lang; label: string }[] = [
  { value: 'en', label: 'English' },
  // Endonym, not "Thai": a reader who needs this option cannot necessarily read
  // the English name of their own language.
  { value: 'th', label: 'ไทย' },
];

export const STORAGE_KEY = 'tl.lang';

export interface Translate {
  (key: MessageKey, vars?: Record<string, string | number>): string;
}

export interface I18nValue {
  t: Translate;
  lang: Lang;
  setLang: (lang: Lang) => void;
}

export const I18nContext = createContext<I18nValue | null>(null);

export function useI18n(): I18nValue {
  const context = useContext(I18nContext);
  if (!context) throw new Error('useI18n must be used inside <I18nProvider>');
  return context;
}

/** Shorthand for the common case of needing nothing but the translator. */
export function useT(): Translate {
  return useI18n().t;
}

export type { MessageKey };
